import * as Stickyfill from 'stickyfilljs';

const stickyElement = document.querySelectorAll('.is-sticky');

if (stickyElement) {
  Stickyfill.add(stickyElement);
}
